import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import circleSolid from '../../media/chart/CircleSolid.svg';
import circleDotted from '../../media/chart/CircleDotted.svg';
import diamondSolid from '../../media/chart/DiamondSolid.svg';
import diamondDotted from '../../media/chart/DiamondDotted.svg';
import triangleDownSolid from '../../media/chart/TriangleDownSolid.svg';
import triangleDownDotted from '../../media/chart/TriangleDownDotted.svg';
import triangleUpSolid from '../../media/chart/TriangleUpSolid.svg';
import triangleUpDotted from '../../media/chart/TriangleUpDotted.svg';

const metricPickerBorderColor = [
  '#2e76bc',
  '#022F22',
  '#e2068c',
  '#4a0b3f',
];

const getMetricPickerBorderStyle = column => ({
  ...shorthands.border('1px', 'solid', metricPickerBorderColor[column]),
});

export const useStyles = makeStyles({
  metricPickerItem: {
    display: 'flex',
    flexGrow: 1,
    flexBasis: 0,
    flexDirection: 'column',
    ...shorthands.borderRadius('4px'),
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke1),
    minWidth: '1px',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    height: '70px',
    maxWidth: '160px',
    boxSizing: 'border-box',
    '&.ba-pc-metric-picker-item-size-s': {
      width: '100%',
      maxWidth: 'unset',
      flexBasis: 'unset',
    },
    '&.ba-pc-metric-picker-item-size-m': {
      width: 'calc((100% - 12px) / 2)',
      maxWidth: 'unset',
      flexBasis: 'unset',
    },
    '&.ba-pc-metric-picker-item-index-0': {
      '& .original-marker': {
        backgroundImage: `url("${circleSolid}")`,
      },
      '& .comparison-marker': {
        backgroundImage: `url("${circleDotted}")`,
      },
      ...getMetricPickerBorderStyle(0),
    },
    '&.ba-pc-metric-picker-item-index-1': {
      '& .original-marker': {
        backgroundImage: `url("${diamondSolid}")`,
      },
      '& .comparison-marker': {
        backgroundImage: `url("${diamondDotted}")`,
      },
      ...getMetricPickerBorderStyle(1),
    },
    '&.ba-pc-metric-picker-item-index-2': {
      '& .original-marker': {
        backgroundImage: `url("${triangleDownSolid}")`,
      },
      '& .comparison-marker': {
        backgroundImage: `url("${triangleDownDotted}")`,
      },
      ...getMetricPickerBorderStyle(2),
    },
    '&.ba-pc-metric-picker-item-index-3': {
      '& .original-marker': {
        backgroundImage: `url("${triangleUpSolid}")`,
      },
      '& .comparison-marker': {
        backgroundImage: `url("${triangleUpDotted}")`,
      },
      ...getMetricPickerBorderStyle(3),
    },
  },
  dropdown: {
    ...shorthands.flex(0, 0, 'auto'),
    alignSelf: 'stretch',
  },
  pickerName: {
    ...shorthands.overflow('hidden'),
    fontSize: '14px',
    height: '19px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  dropdownTriggerButton: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    ...shorthands.padding('2px', '12px'),
  },

  toggleButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    ...shorthands.padding('0px', '8px', '8px', '8px'),
  },
  pickerValue: {
    display: 'block',
    alignItems: 'center',
    ...shorthands.overflow('hidden'),
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: '#797775',
    fontSize: '24px',
    fontWeight: '600',
  },
  imageIndicator: {
    ...shorthands.flex(0, 0, 'auto'),
    display: 'flex',
    minWidth: '14px',
    height: '27px',
  },
  marker: {
    backgroundRepeat: 'no-repeat',
    width: '14px',
    height: '27px',
    backgroundPositionX: 'center',
    backgroundPositionY: 'center',
    backgroundSize: 'contain',
    ...shorthands.flex(0, 0, 'auto'),
  },
});
